export default __webpack_public_path__ + "static/media/modalSmartStore.fcae5c0c.png";